import React, { lazy, Suspense } from 'react';

const LazyPopOrderForm = lazy(() => import('./PopOrderForm'));

const PopOrderForm = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyPopOrderForm {...props} />
  </Suspense>
);

export default PopOrderForm;
